import React from 'react'

class ErrorHandler extends React.Component {

   render() {
      return (
         <div>
				Seite nicht gefunden
			</div>
      );
   }
}

export default ErrorHandler



// WEBPACK FOOTER //
// ./src/components/ErrorHandler.js